<template>
  <div class="text-center">
    <AppDialog
      v-model="dialogModel"
      width="70vw"
      scrollable
      @close="close(false)"
    >
      <template #title>
        Send Email {{ report.reportNumber }}
      </template>
      <br>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="subject"
            class="pb-2"
            name="subject"
            label="Subject"
            required
            :rules="rules"
          />
          <v-textarea
            v-model="customMessage"
            name="custom_message"
            label="Custom Message"
            variant="outlined"
          />
          <h4>Please enter emails separated by a comma</h4>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="emails"
                name="emails"
                label="Emails"
                required
                :rules="rules"
              />
            </v-col>
            <v-col cols="4">
              <v-checkbox
                v-model="useDefaultEmails"
                name="default_emails"
                label="Use default emails?"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn @click="close(false)">
          <v-icon>mdi-cancel</v-icon>
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn @click="togglePreviewDialog(true)">
          <v-icon>mdi-email-search</v-icon>
          Preview Email
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="saving"
          @click="() => submit()"
        >
          <v-icon>mdi-email</v-icon>
          <span v-show="!saving">Send Email</span>
          <pulse-loader :loading="saving" />
        </v-btn>
      </v-card-actions>
    </AppDialog>
    <email-preview
      :dialog="previewDialog"
      :custom-message="customMessage"
      :subject="subject"
      :emails="emails"
      :action="submit"
      :close="togglePreviewDialog"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppDialog from "@/components/AppDialog";
import PulseLoader from "vue-spinner/src/PulseLoader";
import EmailPreview from "@/components/EmailPreview.vue";

export default {

  components: {
    AppDialog,
    PulseLoader,
    EmailPreview,
  },
  props: {
    dialog: Boolean,
    close: {
      type: Function,
      default: null
    }
  },

  emits: ['update:dialog'],

  data() {
    return {
      subject: null,
      customMessage: null,
      emails: null,
      previewDialog: false,
      mailList: [],
      rules: [(v) => !!v || "This field is required!"],
      valid: true,
      useDefaultEmails: false,
    }
  },
  
  computed: {
    ...mapGetters({
      saving: "report/details/emailSaving",
      report: "report/details/report",
    }),
    dialogModel: {
      get () { return this.dialog },
      set (value) { this.$emit('update:dialog', value) },
    },
  },

  watch: {
    dialog() {
      this.subject = null;
      this.emails = null;
      this.customMessage = null;
    },
    useDefaultEmails() {
      if (this.useDefaultEmails) {
        this.emails = "grace@bcwhales.org,janie@bcwhales.org";
      }
      else {
        this.emails = "";
      }
    },
  },
  methods: {
    ...mapActions({
      sendEmail: "report/details/sendEmail",
      previewEmail: "report/details/previewEmail",
    }),
    async submit() {
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.mailList = this.emails ? this.emails.split(",") : []
      // remove whitespace from strings, if any
      for (let i = 0; i < this.mailList.length; i++) {
        this.mailList[i].trim();
      }
      await this.sendEmail({
        reportId: this.report.id,
        emailRequest: {
          customMessage: this.customMessage,
          subject: this.subject,
          mailList: this.mailList,
        }
      });
      this.close(false);
    },
    async togglePreviewDialog(dialog) {
      await this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      if (dialog) {
        this.mailList = this.emails.split(",")
        // remove whitespace from strings, if any
        for (const address of this.mailList) {
          address.trim();
        }

        await this.previewEmail({
          reportId: this.report.id,
          emailRequest: {
            customMessage: this.customMessage,
            subject: this.subject,
            mailList: this.mailList,
          }
        });
      }
      this.previewDialog = dialog;
    },
  },
};
</script>

<style scoped></style>
